import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button,
  Chip,
  IconButton,
  Menu,
  MenuItem,
  Avatar,
  Snackbar,
  Alert,
} from "@mui/material";
import {
  Send as SendIcon,
  MoreVert as MoreVertIcon,
  Visibility as ViewIcon,
  ContentCopy as DuplicateIcon,
  Delete as DeleteIcon,
  Campaign as CampaignIcon,
} from "@mui/icons-material";
import CreateBroadcastDialog from "./CreateBroadcastDialog";
import { errorMessage } from "../shared/utils/validators";
import BroadcastService from "../services/BroadcastService";
import Broadcast from "../models/Broadcast";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";

const BroadcastMessagesView = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeBroadcast, setActiveBroadcast] = useState(null);
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const [editBroadcast, setEditBroadcast] = useState(null);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [broadcasts, setBroadcasts] = useState([]);

  function fetch() {
    BroadcastService.getAllBroadcast().then((res) => setBroadcasts(res));
  }

useEffect(() => {
  fetch();
}, []);
  const handleMoreOptionsClick = (event, broadcast) => {
    setAnchorEl(event.currentTarget);
    setActiveBroadcast(broadcast);
  };

  const handleMoreOptionsClose = () => {
    setAnchorEl(null);
    setActiveBroadcast(null);
  };

  const handleEditBroadcast = () => {
    setEditBroadcast(activeBroadcast);
    setCreateDialogOpen(true);
    handleMoreOptionsClose();
  };

  const handleViewBroadcast = () => {
    console.log("View broadcast:", activeBroadcast);
    handleMoreOptionsClose();
  };

  const handleDuplicateBroadcast = () => {
    console.log("Duplicate broadcast:", activeBroadcast);
    handleMoreOptionsClose();
  };

  const handleDeleteBroadcast = () => {
    console.log("Delete broadcast:", activeBroadcast);
    handleMoreOptionsClose();
  };

  const handleNewBroadcast = () => {
    setEditBroadcast(null);
    setCreateDialogOpen(true);
  };

  async function handleSaveBroadcast(broadcastData) {
    console.log("Saving broadcast:", broadcastData);
    const model = new Broadcast();
    model.setBroadCastName(broadcastData.broadcastName);
    model.setScheduleDate(broadcastData.scheduleDate);
    model.setSelectedTemplate(broadcastData.selectedTemplate);
    model.setSelectedContacts(broadcastData.selectedContacts);
    model.setSelectedGroups(broadcastData.selectedGroups);
    model.setTemplateVariables(broadcastData.templateVariables);
    model.setSendnow(broadcastData.sendNow);
    if (editBroadcast && editBroadcast.getId()) {
      model.setId(editBroadcast.getId());
    }
    try {
      if (editBroadcast) {
        await BroadcastService.updateBroadCastMessage(model);
        setSnackbar({
          open: true,
          message: "Broadcast updated successfully!",
          severity: "success",
        });
        setCreateDialogOpen();
      } else {
        await BroadcastService.createBroadCastMessage(model);
        setSnackbar({
          open: true,
          message: "Broadcast created successfully!",
          severity: "success",
        });
      }
      fetch(false);
    } catch (error) {
      const message = errorMessage(error);
       if (message) {
          setSnackbar({
            open: true,
            message: `${message}`,
            severity: "error",
          });
        } else {
          setSnackbar({
            open: true,
            message: 'Something went wrong',
            severity: "error",
          });
        }
      console.log('error', error);
    }
    setEditBroadcast(null);
  }

  const getStatusColor = (status) => {
    switch (status) {
      case "Sent":
        return { bg: "#e8f5e8", color: "#2e7d32" };
      case "Scheduled":
        return { bg: "#e3f2fd", color: "#1976d2" };
      case "In Progress":
        return { bg: "#fff3e0", color: "#f57c00" };
      case "Failed":
        return { bg: "#ffebee", color: "#d32f2f" };
      default:
        return { bg: "#f5f5f5", color: "#666" };
    }
  };

  const formatDateTime = (dateTimeString) => {
    const date = new Date(dateTimeString);
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      {/* Header */}
         {broadcasts.length > 0 && (
      <Paper
        elevation={0}
        sx={{
          p: 3,
          borderBottom: "1px solid #e0e0e0",
          backgroundColor: "#fff",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Avatar sx={{ bgcolor: "#1976d2", width: 40, height: 40 }}>
              <CampaignIcon />
            </Avatar>
            <Box>
              <Typography variant="h5" sx={{ fontWeight: 600, color: "#333", fontFamily: 'Poppins, sans-serif'}}>
                Broadcast Messages
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Poppins, sans-serif' }}>
                Manage your broadcast campaigns
              </Typography>
            </Box>
          </Box>
          <Button
            variant="contained"
            startIcon={<SendIcon />}
            onClick={handleNewBroadcast}
            sx={{
              borderRadius: 2,
              textTransform: "none",
              boxShadow: "0 2px 8px rgba(25, 118, 210, 0.3)",
              fontFamily: 'Poppins, sans-serif',
            }}
          >
            New Broadcast
          </Button>
        </Box>
      </Paper>
          )}
{/* ===== EMPTY BROADCAST PLACEHOLDER ===== */}
{broadcasts.length === 0 && (
  <Box
    sx={{
      flex: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      textAlign: "center",
      py: 8,
      color: "#9ca3af",
    }}
  >
    <CampaignOutlinedIcon sx={{ fontSize: 80, mb: 2 }} />

    <Typography
      sx={{
        fontSize: 20,
        fontWeight: 600,
        mb: 0.5,
        color: "#374151",
        fontFamily: "Poppins, sans-serif",
      }}
    >
      No Broadcast Messages Yet
    </Typography>

    <Typography
      sx={{
        fontSize: 14,
        maxWidth: 380,
        mb: 2,
        fontFamily: "Poppins, sans-serif",
      }}
    >
      Create broadcast campaigns to send messages to multiple contacts at once
    </Typography>

    <Button
      variant="contained"
      startIcon={<SendIcon />}
      onClick={handleNewBroadcast}
      sx={{
        borderRadius: 2,
        textTransform: "none",
        px: 3,
      }}
    >
      New Broadcast
    </Button>
  </Box>
)}

      {/* Table */}
      {broadcasts.length > 0 && (
      <TableContainer
        component={Paper}
        elevation={0}
        sx={{
          flex: 1,
          borderRadius: 0,
          "& .MuiTable-root": {
            borderCollapse: "separate",
            borderSpacing: 0,
          },
        }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  backgroundColor: "#f5f5f5",
                  // borderBottom: "2px solid #e0e0e0",
                  fontWeight: 600,
                  fontFamily: 'Poppins, sans-serif',
                  color: "#333",
                }}
              >
                Name
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: "#f5f5f5",
                  // borderBottom: "2px solid #e0e0e0",
                  fontWeight: 600,
                  color: "#333",
                  fontFamily: 'Poppins, sans-serif',
                }}
              >
                Schedule
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  backgroundColor: "#f5f5f5",
                  // borderBottom: "2px solid #e0e0e0",
                  fontWeight: 600,
                  color: "#333",
                  fontFamily: 'Poppins, sans-serif',
                }}
              >
                Successful
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  backgroundColor: "#f5f5f5",
                  // borderBottom: "2px solid #e0e0e0",
                  fontWeight: 600,
                  color: "#333",
                  fontFamily: 'Poppins, sans-serif',
                }}
              >
                Read
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  backgroundColor: "#f5f5f5",
                  // borderBottom: "2px solid #e0e0e0",
                  fontWeight: 600,
                  color: "#333",
                  fontFamily: 'Poppins, sans-serif',
                }}
              >
                Replied
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  backgroundColor: "#f5f5f5",
                  // borderBottom: "2px solid #e0e0e0",
                  fontWeight: 600,
                  color: "#333",
                  fontFamily: 'Poppins, sans-serif',
                }}
              >
                Failed
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  backgroundColor: "#f5f5f5",
                  // borderBottom: "2px solid #e0e0e0",
                  fontWeight: 600,
                  color: "#333",
                  fontFamily: 'Poppins, sans-serif',
                }}
              >
                Recipients
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: "#f5f5f5",
                  // borderBottom: "2px solid #e0e0e0",
                  fontWeight: 600,
                  color: "#333",
                  fontFamily: 'Poppins, sans-serif',
                }}
              >
                Status
              </TableCell>
              <TableCell
                align="right"
                sx={{
                  backgroundColor: "#f5f5f5",
                  // borderBottom: "2px solid #e0e0e0",
                  fontWeight: 600,
                  color: "#333",
                  fontFamily: 'Poppins, sans-serif',
                }}
              >
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {broadcasts.map((broadcast) => (
              <TableRow
                key={broadcast.getId()}
                sx={{
                  "&:hover": {
                    backgroundColor: "#f8f9fa",
                  },
                  "&:last-child td": {
                    borderBottom: 0,
                  },
                }}
              >
                <TableCell>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 500,
                      color: "#1976d2",
                      cursor: "pointer",
                      "&:hover": {
                        textDecoration: "underline",
                      },
                    }}
                  >
                    {broadcast.getBroadCastName()}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">
                    {broadcast.getScheduleDate() ? formatDateTime(broadcast.getScheduleDate()): 'Not Scheduled'}
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: 500,
                      color: "#2e7d32",
                    }}
                  >
                    {broadcast.getSuccess()}
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: 500,
                      color: "#1976d2",
                    }}
                  >
                    {broadcast.getRead()}
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: 500,
                      color: "#f57c00",
                    }}
                  >
                    {broadcast.getReplied()}
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: 500,
                      color: "#d32f2f",
                    }}
                  >
                    {broadcast.getFailed()}
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Typography variant="body2" sx={{ fontWeight: 500 }}>
                    {broadcast.getRecipients()}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Chip
                    label={broadcast.getStatus()}
                    size="small"
                    sx={{
                      backgroundColor: getStatusColor(broadcast.getStatus()).bg,
                      color: getStatusColor(broadcast.getStatus()).color,
                      fontWeight: 500,
                    }}
                  />
                </TableCell>
                <TableCell align="right">
                  <IconButton
                    onClick={(event) =>
                      handleMoreOptionsClick(event, broadcast)
                    }
                    sx={{ color: "#666" }}
                  >
                    <MoreVertIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      )}
      {/* More Options Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMoreOptionsClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          sx: {
            borderRadius: 2,
            boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
            minWidth: 150,
          },
        }}
      >
        {/* <MenuItem onClick={handleViewBroadcast} sx={{ gap: 1 }}>
          <ViewIcon fontSize="small" />
          View
        </MenuItem> */}
        <MenuItem onClick={handleEditBroadcast} sx={{ gap: 1 }}>
          <SendIcon fontSize="small" />
          Edit
        </MenuItem>
        {/* <MenuItem onClick={handleDuplicateBroadcast} sx={{ gap: 1 }}>
          <DuplicateIcon fontSize="small" />
          Duplicate
        </MenuItem> */}
        <MenuItem
          onClick={handleDeleteBroadcast}
          sx={{ gap: 1, color: "#d32f2f" }}
        >
          <DeleteIcon fontSize="small" />
          Delete
        </MenuItem>
      </Menu>

      {/* Create Broadcast Dialog */}
      <CreateBroadcastDialog
        open={createDialogOpen}
        onClose={() => { setCreateDialogOpen(false); setEditBroadcast(null); }}
        onSave={handleSaveBroadcast}
        editBroadcast={editBroadcast}
      />

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ borderRadius: 2 }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default BroadcastMessagesView;
